const driverShifts = {
  driverShifts: 'Driver Shifts',

  driverLink: 'Driver Schedule App URL',

  filters: {
    areas: 'Zones',
    drivers: 'Drivers',
    suppliers: 'Suppliers',
    vehicles: 'Vehicles',
    locations: 'Locations',
    airportLocations: 'Airport Locations',
    attributes: 'Attributes',
  },

  calendarTypes: {
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
  },

  driverfilter: {
    all: 'All Drivers',
    withShift: 'Drivers with Shifts',
    withoutShifts: 'Drivers Without Shifts',
  },

  header: {
    create: 'Create',
    createMulti: 'Create Multiple',
    switchButton: {
      label: 'View',
      table: 'Table',
      calendar: 'Calendar',
    },
  },

  moreActions: {
    delete: 'Delete',
  },
  toast: {
    error: {
      sameDate: 'From Date and To Date cannot be identical',
      badResponse: '[Driver Shift] bad server response',
      create: {},
      edit: {},
    },
    success: {
      create: {},
      edit: {},
    },
  },
  headerButtons: {
    createBtn: 'Create',
    createMultiBtn: 'Create Multiple Shifts',
    deleteBtn: 'Delete',
  },

  table: {
    actions: {
      delete: 'Delete',
      export: 'Export',
    },
    headers: {
      name: 'Driver',
      email: 'Driver',
      address: 'Address',
      firstTripDistance: '1st Trip Max Distance',
      addrLon: 'Lon',
      addrLat: 'Lat',
      at: 'Created At',
      by: 'Created By',
      areas: 'Zones',
      locations: 'Locations',
      attributes: 'Attributes',
    },
    cells: {
      name: {
        vehicle: 'Vehicle',
      },
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },

  create: {
    successToast: {
      message: 'Success Driver Shift Created!',
    },
    errorToast: {
      message: 'Error Occurred! Could Not Create Driver Shift',
    },

    multi: {
      successToast: {
        message: 'Success Drivers Shifts Created!',
      },
      errorToast: {
        message: 'Error! Select a valid weekday for the driver shift',
      },
    },
    modalAfter24: {
      header: 'Warning',
      body: 'Shifts that have already passed 24 hours cannot be modified',
    },
    modalBefore24: {
      header: 'Warning',
      body: 'Changes made within 24 hours of an existing shift require confirmation. Please confirm to proceed',
    },
  },

  update: {
    successToast: {
      message: 'Success Driver Shift Updated!',
    },
    errorToast: {
      message: 'Error Occurred! Could Not Update Driver Shift',
    },

    formTabs: {
      informationTab: 'Information',
      historyTab: 'History',
    },
  },

  delete: {
    modalError: {
      header: 'Error Occurred',
      body: 'Could Not Update',
    },
    modalSuccess: {
      header: 'Success',
      body: ' - Shifts deleted successfully',
    },
  },

  modalRemoveConfirm: {
    header: 'Warning!',
    bodySingle: 'Are you sure you want to delete this shift?',
    bodyMultiple: 'Are you sure you want to delete these shifts?',
    confirmBtn: 'Delete',
  },

  modalRemoveSingelConfirm: {
    header: 'Delete Driver Shift',
    body: 'You are about to delete 1 driver shift',
  },

  form: {
    header: {
      createDriverShift: {
        title: 'Create',
      },

      createMultipleDriverShift: {
        title: 'Create Multiple',
      },

      updateDriverShift: {
        title: 'Update',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Submit',
        update: 'Submit',
        delete: 'Delete',
      },
    },

    information: {
      details: {
        header: 'Driver Details',
        fields: {
          driver: 'Driver',
          vehicle: '(Vehicle: {{currentVehicle}})',
        },
      },
      shiftDetails: {
        header: 'Shift Details',
        overnightShiftNote: 'Note: This is an overnight shift',
        fields: {
          fromDate: 'Start',
          toDate: 'End',
          address: 'Address',
          firstTripDistance: '1st Trip Max Distance',
          attributes: 'Attributes',
          areas: 'Zones',
          areasPriorityMode: {
            title: 'Mode',
            options: {
              allStops: 'All Stops',
              firstPickDrop: 'First Pick & Drop',
              legAOrigin: 'Leg A Origin',
            },
          },
          areasPriorityLevel: {
            title: 'Priority',
            options: {
              low: 'Low',
              medium: 'Medium',
              high: 'High',
              strict: 'Strict',
            },
          },
          suppliers: 'Suppliers',
          allowSharedRides: 'Allow Shared Rides',
        },
      },
      locationsSettings: {
        header: 'Locations Settings',
        fields: {
          locations: 'Locations',
          enableInBetweenRides: 'Enable In-Between Rides',
        },
      },
    },

    validations: {
      drivers: {
        required: 'Drivers is required',
        drivers: '',
      },
      driver: {
        required: 'Driver is required',
        driver: '',
      },
      start: {
        required: 'Start is required',
        start: '',
      },
      end: {
        required: 'End is required',
        differentTimes: "A shift's start and end times must be different.",
        end: '',
      },
    },
    select: 'Select',
    buttons: {
      addBreak: '+ Add Break',
    },
  },

  formMulti: {
    header: {
      createMultiDriverShift: {
        title: 'New Multi Drivers Shifts',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Submit',
        update: 'EDIT MULTI DRIVERS SHIFTS',
      },
    },

    information: {
      details: {
        header: 'Driver Details',
        fields: {
          drivers: 'Drivers',
        },
      },
      shiftDetails: {
        header: 'Shift Details',
        fields: {
          fromDate: 'From Date',
          toDate: 'To Date',
          weeksDays: 'Week Days',
          fromHour: 'From Hour',
          tohour: 'To Hour',
          breakStart: 'Break Start',
          breakEnd: 'Break End',
        },
      },
    },
    validations: {
      drivers: {
        required: 'Drivers is required',
      },
      driver: {
        required: 'Driver is required',
      },
      start: {
        required: 'Start is required',
      },
      end: {
        required: 'End is required',
      },
    },
    select: 'Select',
  },

  totalDriverShifts: 'Total Driver Shifts',

  calendarTable: {
    filters: {
      areas: 'Zones',
      drivers: 'Drivers',
      suppliers: 'Suppliers',
      attributes: 'Attributes',
    },

    daily: {
      actions: {
        delete: 'Delete',
        deleteTooltip: 'The driver\'s current day does not contain any shifts',
      },
      noResults: 'No Results Found',
      noResultsSubHeader: 'We can\'t find any item matching your search',
      selectAll: 'Select All',
      selectAllPages: 'All {{limit}} items on this page are selected. ',
      btnSelectAllResults: ' Select all {{totalDrivers}} items',
      btnunselectAllResults: 'Clear Selection',
      totalDrivers: 'Total Drivers: {{total}}',
      totalShifts: 'Total Shifts: {{total}}',
    },
    weekly: {
      actions: {
        delete: 'Delete',
      },
    },
    emptyCell: {
      dayOff: 'Day Off',
    },
    headers: {
      driverName: 'Name',
      monday: 'Monday {{day}}',
      tuesday: 'Tuesday {{day}}',
      wednesday: 'Wednesday {{day}}',
      thursday: 'Thursday {{day}}',
      friday: 'Friday {{day}}',
      saturday: 'Saturday {{day}}',
      sunday: 'Sunday {{day}}',
    },
  },
};

export default driverShifts;
